import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'min' })
export class MinPipe implements PipeTransform {
  transform(value: number): string {
    return `${Math.floor(value)}min`;
  }
}
